import React, { useEffect } from 'react'
import { DataConnectorClient } from '~/plugins/data-connector/client'
import { CardAccountAuthorizationUIProps } from '~/plugins/data-connector/client/components/CardAccountAuthorization'
import { Toolbox } from '~/plugins/toolbox/shared'

type ValueType = {
  providerAccountId: string
  scope: string
  isAuthorized: boolean
  isCorrupted?: boolean
}

type Props = {
  id?: string
  value?: ValueType[]
  initialValues?: ValueType[]
  providerAccountId?: string
  scope?: string
  ui?: CardAccountAuthorizationUIProps
  onChange?: (value: ValueType[]) => void
}

export const ProviderAccountAuthorization: React.FC<Props> = ({
  id,
  value,
  initialValues,
  providerAccountId,
  scope,
  ui,
  onChange,
}) => {
  const providerAccountIdFound = value?.[0]?.providerAccountId
  const isAuthorized =
    Toolbox.Utility.isDefined(providerAccountIdFound) &&
    providerAccountIdFound === providerAccountId

  useEffect(() => {
    if (value && !isAuthorized) {
      onChange?.(null)
    }
  }, [isAuthorized])

  const handleSuccess = () => {
    onChange?.([
      { providerAccountId, scope, isAuthorized: true, isCorrupted: false },
    ])
  }

  const handleCorrupted = () => {
    const isAlreadyCorrupted = value?.[0]?.isCorrupted
    if (isAlreadyCorrupted) {
      return
    }

    onChange?.([{ providerAccountId, scope, isAuthorized, isCorrupted: true }])
  }

  return (
    <span id={id}>
      <DataConnectorClient.CardAccountAuthorization
        providerAccountId={providerAccountId}
        ui={ui}
        scope={scope}
        onSuccess={handleSuccess}
        onCorrupted={handleCorrupted}
        authorized={isAuthorized}
      />
    </span>
  )
}
